import React from 'react';
import { IoMdCheckmarkCircle } from "react-icons/io";

const ThankYouMessageForm = () => {
    return(
        <React.Fragment>
            <h3>Thank you for your submission! <IoMdCheckmarkCircle/></h3>    
        </React.Fragment>
    )
}

export default ThankYouMessageForm;